import React from 'react';

export default ({ className = 'h2' }) => {
  return (
    <div className={'loading ' + className}>
      <i className="fa fa-circle-o-notch fa-spin" />
    </div>
  );
};
